import LinkLightAsAnchor from './LinkLightAsAnchor';

export default LinkLightAsAnchor;
